import { useEffect } from "react";

export const useMessageHandler = (usuario: any) => {
  useEffect(() => {
    const handleMessage = (event: any) => {
      try {
        if (event.origin === "https://drive.google.com") return;

        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data?.device?.platform) {
          localStorage.setItem("osName", data?.device?.platform);
        }
      } catch (err) {
        console.error("Error al parsear mensaje:", err);
      }
    };

    // Escuchar mensajes entrantes
    document.addEventListener("message", handleMessage);
    window.addEventListener("message", handleMessage); // Para compatibilidad con iOS

    return () => {
      // Limpiar listeners cuando el componente se desmonte
      document.removeEventListener("message", handleMessage);
      window.removeEventListener("message", handleMessage);
    };
  }, [usuario]);
};
